import BerichtFoerderantragAsideFilters from "./BerichtFoerderantragAsideFilters/BerichtFoerderantragAsideFilters.vue";

export default {
  BerichtFoerderantragAsideFilters,
};
